import { get } from "lodash-es";

import { AiNodeJsonSchemaPropertyUI } from "src/aiNode/types";
import { AiNodeV2ResponseFormatConfigTypeEnum } from "src/clients/flow-api";
import { AiNodeV2Data } from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";

export const extractAiNodeV2Fields = (
  data: AiNodeV2Data,
): SearchableField[] => {
  const fields: SearchableField[] = [];
  const responseFormat = data.inference.response_format.type;

  data.prompts.messages.forEach((message) => {
    message.content.forEach((content) => {
      if (content.block_type === "text" && content.text.expression) {
        fields.push({
          id: content.text.id,
          value: content.text.expression,
        });
      }
    });
  });

  if (responseFormat === AiNodeV2ResponseFormatConfigTypeEnum.TEXT) {
    fields.push({
      id: `${data.response.default.id}:field`,
      value: `data.${data.response.default.mapped_to}`,
    });
  } else {
    Object.keys(data.response).forEach((responseKey) => {
      if (responseKey === "default") {
        return;
      }

      const responseField = data.response[responseKey];
      const responseFieldJsonSchema = get(
        data,
        `inference.response_format.json_schema.properties["${responseKey}"]`,
      ) as unknown as AiNodeJsonSchemaPropertyUI;

      if (responseField?.mapped_to) {
        fields.push({
          id: `${responseField.id}:field`,
          value: `data.${responseField.mapped_to}`,
        });
      }

      if (responseFieldJsonSchema?.description) {
        fields.push({
          id: `${responseField.id}:description`,
          value: responseFieldJsonSchema.description,
        });
      }
    });
  }

  if (data.prompts.system_prompt.active) {
    fields.push({
      id: data.prompts.system_prompt.id,
      value: data.prompts.system_prompt.expression,
    });
  }

  return fields;
};
